<template>
    <div class="sportFootballMatchActionActive">
      <!-- <el-button type="danger" icon="el-icon-delete" plain size="mini" v-if="!action.active"/> -->
      <el-switch v-model="active" inactive-text="Off" active-text="On" active-color="#13ce66"/>
    </div>
</template>

<script>
export default {
  name: 'SportFootballMatchActionActive',
  props: {
    action: Object
  },
  computed: {
    active: {
      get () {
        return this.action.active
      },
      set (value) {
        this.$store.dispatch('Sport/Football/Match/putAction', { id: this.action.id, active: value })
      }
    }
  }
}
</script>

<style>
.sportFootballMatchActionActive {
  grid-area: active;
  justify-content: center;
  display:flex;
}
.sportFootballMatchActionActive .el-switch__label{
  color:var(--color-font-grey-light)
}
.sportFootballMatchActionActive .el-switch__label.is-active{
  color:var(--color-font-grey)
}
.sportFootballMatchActionActive > button{
  z-index:0;
  align-self: center;
}
.sportFootballMatchActionActive > div{
  align-self: center;
}
</style>
